import { useNetworkWLANsCounts } from 'features/networkAi/hooks'
import { useIntl } from 'react-intl'
import { networkStatusWLANsMessages } from './messages'
import {
  NetworkStatusWLANsContainer,
  NetworkStatusWLANsHeader,
  NetworkStatusWLANsHeaderTitle,
  NetworkStatusWLANsBody,
  NetworkStatusWLANsItem,
  NetworkStatusWLANsCount,
  NetworkStatusWLANsCountLabel,
} from './styles'

interface WLANsCardProps {
  siteId: string
}

function WLANsCard({ siteId }: WLANsCardProps) {
  const { formatMessage } = useIntl()
  const { wlansTotal } = useNetworkWLANsCounts({ siteId })

  return (
    <NetworkStatusWLANsContainer>
      <NetworkStatusWLANsHeader>
        <NetworkStatusWLANsHeaderTitle>WLANs</NetworkStatusWLANsHeaderTitle>
      </NetworkStatusWLANsHeader>

      <NetworkStatusWLANsBody>
        <NetworkStatusWLANsItem>
          <NetworkStatusWLANsCount>{wlansTotal}</NetworkStatusWLANsCount>
          <NetworkStatusWLANsCountLabel>
            {formatMessage(networkStatusWLANsMessages.wlansTotalText)}
          </NetworkStatusWLANsCountLabel>
        </NetworkStatusWLANsItem>
      </NetworkStatusWLANsBody>
    </NetworkStatusWLANsContainer>
  )
}

export default WLANsCard
